import { render } from "./tw-ws-block.vue?vue&type=template&id=513530ab"
import script from "./tw-ws-block.vue?vue&type=script&lang=js"
export * from "./tw-ws-block.vue?vue&type=script&lang=js"
script.render = render

export default script